var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoimage02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.953,
    height: 24,
    viewBox: "0 0 26.953 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M25.156,0a1.587,1.587,0,0,1,1.123.533,2.037,2.037,0,0,1,.674,1.6v20a2.251,2.251,0,0,1-.449,1.333A2.173,2.173,0,0,1,25.156,24H1.8a2.173,2.173,0,0,1-1.348-.533A3.223,3.223,0,0,1,0,21.867V2.133A2.251,2.251,0,0,1,.449.8C.9.267,1.123,0,1.8,0ZM7.637,4.8A2.337,2.337,0,0,0,5.84,4a2.337,2.337,0,0,0-1.8.8,3.37,3.37,0,0,0-.674,2.133,3.37,3.37,0,0,0,.674,2.133,2.337,2.337,0,0,0,1.8.8,2.337,2.337,0,0,0,1.8-.8,3.37,3.37,0,0,0,.674-2.133A3.37,3.37,0,0,0,7.637,4.8ZM23.584,20,16.846,8l-6.064,9.333L6.738,13.867,3.369,20Z",
    transform: "translate(0 0)",
    fill: "rgba(134,131,132,0.89)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage02);
export default __webpack_public_path__ + "static/media/noimage02.e13c1ca47bb7382093b812cb03f1ba8c.svg";
export { ForwardRef as ReactComponent };